/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-layer-popover-arrow-padding: 6px;
  --nve-sys-layer-popover-arrow-offset: 2px;
  --nve-sys-layer-popover-offset: 2px;
  --nve-sys-interaction-color: var(--color);
  --border-radius: var(--nve-ref-border-radius-sm);
  --border: 0;
  --background: var(--nve-sys-layer-popover-background);
  --color: var(--nve-sys-layer-popover-color);
  --padding: var(--nve-ref-size-200) var(--nve-ref-size-300);
  --box-shadow: var(--nve-ref-shadow-500);
  --font-size: var(--nve-ref-font-size-100);
  --font-weight: var(--nve-ref-font-weight-regular);
  --arrow-transform: translate(0, -2px) rotate(-45deg);
  --width: max-content;
  --height: initial;
  box-shadow: var(--box-shadow);
}

:host([status='muted']) {
  --background: var(--nve-sys-layer-overlay-background);
  --color: var(--nve-sys-layer-overlay-color);
}

[internal-host] {
  padding: var(--padding);
  border-radius: var(--border-radius);
  background: var(--background);
  color: var(--color);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  width: var(--width);
  height: var(--height);
  border: var(--border);
  white-space: initial;
}

[internal-host]:has(nve-icon-button) {
  padding-inline-end: var(--nve-ref-size-800);
}

.arrow {
  width: var(--nve-ref-size-300);
  height: var(--nve-ref-size-300);
  background: var(--background);
  transform: var(--arrow-transform);
  border-radius: var(--nve-ref-size-50);
  position: absolute;
}

nve-icon-button {
  --color: inherit;
  position: absolute;
  inset-block-start: var(--nve-ref-size-50);
  inset-inline-end: var(--nve-ref-size-50);
}

::slotted([nve-text]) {
  color: inherit !important;
}

:host([position*='top']) {
  --arrow-transform: translate(0, -2px) rotate(-45deg);
}

:host([position*='right']) {
  --arrow-transform: translate(2px, 0) rotate(45deg);
}

:host([position*='bottom']) {
  --arrow-transform: translate(0, 2px) rotate(45deg);
}

:host([position*='left']) {
  --arrow-transform: translate(-2px, 0) rotate(45deg);
}
